import { useState } from "react";
import { Star, StarHalf } from "lucide-react";

export function Stars({ value = 0, size = 16 }) {
  return (
    <span className="inline-flex">
      {[1, 2, 3, 4, 5].map((i) => {
        const full = value >= i, half = !full && value >= i - 0.5;
        return half ? <StarHalf key={i} style={{ width: size, height: size }} className="fill-purple-400 text-purple-400" />
          : <Star key={i} style={{ width: size, height: size }} className={full ? "fill-purple-400 text-purple-400" : "text-slate-600"} />;
      })}
    </span>
  );
}

export function StarInput({ value, onChange, disabled }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value || 0;
  return (
    <div className="flex items-center gap-3" data-testid="star-input" onMouseLeave={() => setHover(0)}>
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <span key={i} className="relative h-9 w-9">
            {[i - 0.5, i].map((v, k) => (
              <button key={v} type="button" disabled={disabled} aria-label={`Rate ${v} stars`} data-testid={`rate-${v}`}
                onMouseEnter={() => setHover(v)} onFocus={() => setHover(v)} onClick={() => onChange(v)}
                className={`absolute top-0 h-full w-1/2 ${k ? "right-0" : "left-0"} z-10 disabled:cursor-not-allowed`} />
            ))}
            {shown >= i ? <Star className="h-9 w-9 fill-purple-400 text-purple-400 transition-transform" />
              : shown >= i - 0.5 ? <StarHalf className="h-9 w-9 fill-purple-400 text-purple-400" />
              : <Star className="h-9 w-9 text-slate-600" />}
          </span>
        ))}
      </div>
      <span className="font-mono text-sm text-purple-300">{shown ? shown.toFixed(1) : "–"}</span>
    </div>
  );
}
